import React from "react";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import {
    TextField,
    Button,
} from "@mui/material";



const ResetPasswordSchema = Yup.object().shape({
    password: Yup.string()
    .required("Password is required")
    .min(8, "Password is too short")
    .max(50, "Password is too long")
    .matches(/[!@#$%^&*(),.?":{}|<>]/, "Password must contain at least one special character.") // Special character check
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter.") // Uppercase letter check
    .matches(/[a-z]/, "Password must contain at least one lowercase letter.") // Lowercase letter check
    .matches(/\d/, "Password must contain at least one digit."), // Digit check
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], "Passwords must match")
        .required("Confirm Password is required"),
});


const ResetPasswordForm = ({ handleResetPassword }) => {

    return (

        <Formik
            initialValues={{ password: "", confirmPassword: "" }}
            validationSchema={ResetPasswordSchema}
            onSubmit={(values, { setSubmitting }) => {
                handleResetPassword(values);
            }}
        >

            {({ values, errors, touched, handleChange, handleBlur }) => (

                <Form>

                    <TextField
                        margin="dense"
                        id="password"
                        name="password"
                        label="Password"
                        type="password"
                        fullWidth
                        value={values.password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.password && Boolean(errors.password)}
                        helperText={touched.password && errors.password}
                    />

                    <TextField
                        margin="dense"
                        id="confirmPassword"
                        name="confirmPassword"
                        label="Confirm Password"
                        type="password"
                        fullWidth
                        value={values.confirmPassword}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.confirmPassword && Boolean(errors.confirmPassword)}
                        helperText={touched.confirmPassword && errors.confirmPassword}
                    />

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Reset Password
                    </Button>
                </Form>
            )}

        </Formik>
    );
};

export default ResetPasswordForm;